import { fromEmpty, just } from 'maybeasy';
import { observer } from 'mobx-react';
import { emptyFragment } from '../../../../../../../EmptyFragment';
import { T } from '../../../../../../../Translations';
import LearningCollectionEditStore from '../../../../Edit/Store';
import { SectionContext } from '../../../../Types';
import { filteredScheduledProgramInstanceOptions } from '../../DateSelection';
import Store from '../Store';
import { ExperiencesResource } from '../Types';
import SelectableDate from './SelectableDate';
import Subheading from './Subheading';
import SubmitButtons from './SubmitButtons';

interface Props {
  learningCollectionStore: LearningCollectionEditStore;
  experiences: ExperiencesResource;
  store: Store;
  context: SectionContext;
}

function Body({ learningCollectionStore, experiences, store, context }: Props) {
  return just({})
    .assign('experienceResource', store.experienceResource)
    .assign('productLicense', store.selectedProductLicense)
    .map(({ experienceResource, productLicense }) => (
      <div className="mt-52 flex flex-col px-11">
        <Subheading experiences={experiences} store={store} resource={experienceResource} />
        <div className="mt-4">
          <T
            kind="Advanced Leader Programs are scheduled and run 5 times per year in a cohort structure. {{name}} is..."
            name={experienceResource.payload.title.text}
          />
        </div>
        <div className="mt-12 font-semibold">
          <T kind="Select Start Date(s)" />
        </div>
        {fromEmpty(
          filteredScheduledProgramInstanceOptions(
            experienceResource.payload.programInstanceOptions.scheduled,
            productLicense,
            learningCollectionStore,
          ),
        )
          .map(() => (
            <SelectableDate
              resource={experienceResource}
              store={store}
              productLicense={productLicense}
              learningCollectionStore={learningCollectionStore}
            />
          ))
          .getOrElse(() => (
            <div>
              <T kind="No Scheduled Dates" />
            </div>
          ))}

        <SubmitButtons
          learningCollectionStore={learningCollectionStore}
          experiences={experiences}
          store={store}
          context={context}
          resource={experienceResource}
        />
      </div>
    ))
    .getOrElse(emptyFragment);
}

export default observer(Body);
